export const theme = {
  token: {
    colorPrimary: "#38A890",
    colorLink: '#1B9C85',
    colorLinkHover: '#60C7AE',
    colorLinkActive: '#1B9C85',
  },
};